import React from 'react';
import { Outlet } from 'react-router-dom';
import TabBar from './TabBar';
import UserMenu from './UserMenu';
import SchedulerHealth from './SchedulerHealth';

export default function Shell() {
  return (
    <div className="min-h-screen bg-surface text-surface-text">
      <header className="h-12 flex items-center justify-between px-6 bg-surface-header border-b border-surface-border">
        <div className="flex items-center gap-[10px]">
          <div
            className="w-[22px] h-[22px] bg-accent"
            style={{ clipPath: 'polygon(0 20%, 20% 0, 100% 0, 100% 80%, 80% 100%, 0 100%)' }}
          />
          <span className="font-bold text-[13px] uppercase tracking-[0.12em]">BAN MONITOR</span>
        </div>
        <div className="flex items-center gap-3">
          <SchedulerHealth />
          <UserMenu />
        </div>
      </header>
      <TabBar />
      <main className="max-w-[1100px] mx-auto px-6 py-6">
        <Outlet />
      </main>
    </div>
  );
}
